import React, { useState } from "react"
import VideoFrame from "./VideoFrame"
import style from "./style.module.scss"

//Images
import youtube from "../../images/youtube.png"
import phone from "../../images/1_pay.png"
import watch from "../../images/2_pay.png"

const pay_1 = "V7WVSa-Xm3c"
const pay_2 = "K1W-UOe3kF0"

const HowToPay = () => {
  const [popupVisible, setPopupVisible] = useState(false)
  const [currentVideoId, setId] = useState("")

  return (
    <div className={style.how_to_pay}>
      <div className={style.youtube_container}>
        <img
          src={youtube}
          className={style.youtube}
          alt="Таксомбанк як cплачувати Apple Pay?"
        />
        <div className={style.title}>Як cплачувати Apple Pay?</div>
      </div>
      {popupVisible ? (
        <VideoFrame
          linkTo={`http://www.youtube.com/embed/${currentVideoId}?autoplay=1`}
          onClickHandler={() => setPopupVisible(false)}
        />
      ) : (
        <div className={style.kek}>
          <div
            className={style.wrap}
            onClick={() => {
              setId(pay_1)
              setPopupVisible(true)
            }}
          >
            <h2>Оплата за допомогою iPhone </h2>
            <img src={phone} alt="Оплата за допомогою iPhone Таксомбанк" />
          </div>
          <div
            className={style.wrap}
            onClick={() => {
              setId(pay_2)
              setPopupVisible(true)
            }}
          >
            <h2>Оплата за допомогою Apple Watch</h2>
            <img src={watch} alt="Оплата за допомогою Apple Watch Таксомбанк" />
          </div>
        </div>
      )}

      <div />
    </div>
  )
}

export default HowToPay
